// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "CreditTotalsOverview__textCenter__LQZT4";
export const alert = "CreditTotalsOverview__alert__Nf722";
export const title = "CreditTotalsOverview__title__cWNtA";
export const subtitle = "CreditTotalsOverview__subtitle__g0ehW";
export const tooltipIconWrapper = "CreditTotalsOverview__tooltipIconWrapper__x3+g3";